const SpireRoutingVesselType = {
	BULK_CARRIER_HANDYSIZE: "BULK_CARRIER_HANDYSIZE",
	BULK_CARRIER_HANDYMAX: "BULK_CARRIER_HANDYMAX",
	BULK_CARRIER_SUPRAMAX: "BULK_CARRIER_SUPRAMAX",
	BULK_CARRIER_ULTRAMAX: "BULK_CARRIER_ULTRAMAX",
	BULK_CARRIER_PANAMAX: "BULK_CARRIER_PANAMAX",
	BULK_CARRIER_KAMSARMAX: "BULK_CARRIER_KAMSARMAX",
	BULK_CARRIER_POST_PANAMAX: "BULK_CARRIER_POST_PANAMAX",
	BULK_CARRIER_CAPESIZE: "BULK_CARRIER_CAPESIZE",
	BULK_CARRIER_VLOC: "BULK_CARRIER_VLOC",
	TANKER_CHEMICAL_SMALL: "TANKER_CHEMICAL_SMALL",
	TANKER_CHEMICAL_MEDIUM: "TANKER_CHEMICAL_MEDIUM",
	TANKER_CHEMICAL_LARGE: "TANKER_CHEMICAL_LARGE",
	CONTAINER_FEEDER: "CONTAINER_FEEDER",
	CONTAINER_PANAMAX: "CONTAINER_PANAMAX",
	CONTAINER_POST_PANAMAX: "CONTAINER_POST_PANAMAX",
	CONTAINER_NEW_PANAMAX: "CONTAINER_NEW_PANAMAX",
	CONTAINER_ULCV: "CONTAINER_ULCV",
	LNG_CARRIER_SMALL: "LNG_CARRIER_SMALL",
	LNG_CARRIER_MEDMAX: "LNG_CARRIER_MEDMAX",
	LNG_CARRIER_LOWER_CONVENTIONAL: "LNG_CARRIER_LOWER_CONVENTIONAL",
	LNG_CARRIER_UPPER_CONVENTIONAL: "LNG_CARRIER_UPPER_CONVENTIONAL",
	LNG_CARRIER_Q_FLEX: "LNG_CARRIER_Q-FLEX",
	LNG_CARRIER_Q_MAX: "LNG_CARRIER_Q-MAX",
	LPG_CARRIER_COASTER: "LPG_CARRIER_COASTER",
	LPG_CARRIER_HANDY: "LPG_CARRIER_HANDY",
	LPG_CARRIER_LGC: "LPG_CARRIER_LGC",
	LPG_CARRIER_VLGC: "LPG_CARRIER_VLGC",
	TANKER_CRUDE_HANDYSIZE: "TANKER_CRUDE_HANDYSIZE",
	TANKER_CRUDE_PANAMAX: "TANKER_CRUDE_PANAMAX",
	TANKER_CRUDE_AFRAMAX: "TANKER_CRUDE_AFRAMAX",
	TANKER_CRUDE_SUEZMAX: "TANKER_CRUDE_SUEZMAX",
	TANKER_CRUDE_VLCC: "TANKER_CRUDE_VLCC",
	TANKER_PRODUCT_HANDYSIZE: "TANKER_PRODUCT_HANDYSIZE",
	TANKER_PRODUCT_MR: "TANKER_PRODUCT_MR",
	TANKER_PRODUCT_LR1: "TANKER_PRODUCT_LR1",
	TANKER_PRODUCT_LR2: "TANKER_PRODUCT_LR2"
};

export default SpireRoutingVesselType;
